import React, { useState } from 'react';
import {
  getCalendarDays,
  isDateAvailable,
  isSameDate,
  getMonthNameKorean,
} from '../utils/dateUtils';
import './Calendar.css';

const Calendar = ({ selectedDate, onSelectDate }) => {
  const today = new Date();
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());

  const calendarDays = getCalendarDays(currentYear, currentMonth);

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handleDateClick = (date) => {
    if (date && isDateAvailable(date)) {
      onSelectDate(date);
    }
  };

  const isToday = (date) => {
    if (!date) return false;
    return isSameDate(date, today);
  };

  return (
    <div className="calendar">
      <div className="calendar-header">
        <button
          type="button"
          className="calendar-nav-button"
          onClick={handlePrevMonth}
          aria-label="이전 달"
        >
          ‹
        </button>
        <h3 className="calendar-title">
          {currentYear}년 {getMonthNameKorean(currentMonth)}
        </h3>
        <button
          type="button"
          className="calendar-nav-button"
          onClick={handleNextMonth}
          aria-label="다음 달"
        >
          ›
        </button>
      </div>

      <div className="calendar-weekdays">
        {['일', '월', '화', '수', '목', '금', '토'].map((day, index) => (
          <div
            key={day}
            className={`calendar-weekday ${index === 0 ? 'sunday' : ''}`}
          >
            {day}
          </div>
        ))}
      </div>

      <div className="calendar-days">
        {calendarDays.map((date, index) => {
          if (!date) {
            return <div key={`empty-${index}`} className="calendar-day empty"></div>;
          }

          const available = isDateAvailable(date);
          const selected = isSameDate(date, selectedDate);
          const todayDate = isToday(date);
          const sunday = date.getDay() === 0;

          return (
            <button
              key={index}
              type="button"
              className={`calendar-day ${available ? 'available' : 'disabled'} ${
                selected ? 'selected' : ''
              } ${todayDate ? 'today' : ''} ${sunday ? 'sunday' : ''}`}
              onClick={() => handleDateClick(date)}
              disabled={!available}
            >
              <span className="calendar-day-number">{date.getDate()}</span>
              {todayDate && <span className="today-indicator">오늘</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
